// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3m8DH","messages":"Chat_messages__CkFqb","dateDivider":"Chat_dateDivider__3wx8L"};